import { render, staticRenderFns } from "./ScreensaverShop.vue?vue&type=template&id=3fc11bb0&scoped=true"
import script from "./ScreensaverShop.vue?vue&type=script&lang=js"
export * from "./ScreensaverShop.vue?vue&type=script&lang=js"
import style0 from "./ScreensaverShop.vue?vue&type=style&index=0&id=3fc11bb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc11bb0",
  null
  
)

/* custom blocks */
import block0 from "@/locales/global.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-abdl%2Ffrechdax-abdl-dresden%2Fweb%2Fwebapp%2Fsrc%2Fpages%2Fscreensaver%2FScreensaverShop.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports